export const LoadBoot = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
          <div className="spinner-border" role="status" style={{ width: '6rem', height: '6rem', color: "#6148A1" }}>
            <span className="sr-only"></span>
          </div>
        </div>
  )
}
